import React from 'react';

const ProfileBilling = () => {
  return <span>En construcción</span>;
};

export default ProfileBilling;
